import React, { memo, useContext, useState, useEffect } from 'react'

import DccNotification from 'Pods/ThreeDStudio/Shared/DccNotification/DccNotification'
import ExportNotification from 'Pods/ThreeDStudio/Shared/ExportNotification/ExportNotification'
import { useThreeDStudioStore } from 'Pods/ThreeDStudio/Store'
import ThreeDStudioPageContext from 'Pods/ThreeDStudio/ThreeDStudioPageContext'

import Banner from './Components/Banner/Banner'
import ErrorBannerState from './Components/ErrorBannerState/ErrorBannerState'
import ModelFeedback from './Components/ModelFeedback/ModelFeedback'
import ModelReadyToaster from './Components/ModelReadyToaster/ModelReadyToaster'
import RemixModeNotice from './Components/RemixModeNotice/RemixModeNotice'
import TermsOfServiceNotice from './Components/TermsOfServiceNotice/TermsOfServiceNotice'
import ViewerCanvas from './Components/ViewerCanvas/ViewerCanvas'
import ViewerContent from './Components/ViewerContent/ViewerContent'
import useExportConversionChannel from './Hooks/useExportConversionChannel'

function ViewerArea() {
  const [hasPageLoaded, setHasPageLoaded] = useState(false)
  const { modelReadyToasterEnabled } = useContext(ThreeDStudioPageContext)
  const uploadedModelUrl = useThreeDStudioStore(state => state.modelSettings.inputThreeDUrl)
  const modelUrl = useThreeDStudioStore(state => state.ui.openedModel?.outputAssets?.[0]?.fileUrl)
  const hasFailed = useThreeDStudioStore(state => state.generation.hasFailed)

  useEffect(() => {
    setHasPageLoaded(true)
  }, [])

  useExportConversionChannel()

  return (
    <div className="viewer-area">
      <div className="viewer-area__wrapper">
        <div className="viewer-area__content">
          {!hasFailed && !uploadedModelUrl && !modelUrl && <Banner />}
          {hasFailed && <ErrorBannerState />}
          {hasPageLoaded && (
            <ViewerCanvas>
              {(uploadedModelUrl || modelUrl) && <ViewerContent />}
            </ViewerCanvas>
          )}
          {modelReadyToasterEnabled && <ModelReadyToaster />}
          <TermsOfServiceNotice />
          <RemixModeNotice />
          <DccNotification />
          <ExportNotification />
          <ModelFeedback />
        </div>
      </div>
    </div>
  )
}

export default memo(ViewerArea)
